import type { Components } from '@mui/material/styles';

export default function MuiImageListItemBar(): Components['MuiImageListItemBar'] {
  return {};
}
